export default __webpack_public_path__ + "static/media/sales-and-stock.da501c7f.svg";